const SidePanelTailwind: React.FC = () => {
  return (
    <div className="bottom-4 left-4 lg:left-6 z-[998] fixed lg:absolute bg-[#0B1E3A]/95 shadow-xl backdrop-blur-sm border border-[#1E3A5F] rounded-lg w-auto lg:w-44 overflow-hidden">
      <div className="flex items-center justify-between gap-3 px-3 py-2">
        <p className="font-semibold text-slate-200 text-[10px] uppercase tracking-[0.08em]">Leyenda</p>
        <div className="flex items-center gap-2">
          <div className="bg-emerald-500 border border-emerald-600 rounded-sm w-4 h-2.5" />
          <span className="font-medium text-white text-xs">Cobertura</span>
        </div>
      </div>
    </div>
  );
};

export default SidePanelTailwind;

